module.exports = "<!-- <form class=\"sidebar-form\"></form> -->\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/app-sidebar-form/app-sidebar-form.component.html
// module id = ./src/app/shared/app-sidebar-form/app-sidebar-form.component.html
// module chunks = main